import { Box, LinearProgress } from '@material-ui/core';
import { PaymentMethodType } from '@nemuru-eng/js-api-client';

import {
  Workflow as WorkflowType,
  WorkflowStatus,
} from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/_shared/entities/ProgressWorkflow/AbstractProgressWorkflow';
import { FactoryProgressWorkflow } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/_shared/entities/ProgressWorkflow/FactoryProgressWorkflow';
import { WorkflowStep } from '@/components/modules/CreditCard/Detail/Overview/components/Workflow/components/WorkflowStep';
import { FlexRow } from '@/components/shared/components/FlexRow';
import { Font } from '@/components/shared/components/Font';
import { StatusTag } from '@/components/shared/components/StatusTag/StatusTag';
import { Text } from '@/components/shared/components/Text';
import { useCustomTheme } from '@/hooks/useCustomTheme';

interface ProgressProps {
  status: WorkflowStatus;
  workflow: WorkflowType;
  type: PaymentMethodType;
}

export const Workflow = ({ status, workflow, type }: ProgressProps) => {
  const { palette } = useCustomTheme();

  // useEffect(() => {
  //   const scrollContainer = document.getElementById(WORKFLOW_CONTAINER_ID);
  //   if (scrollContainer) {
  //     scrollContainer.scrollTop = scrollContainer.scrollHeight;
  //   }
  // }, [workflowSteps]);

  const progress = FactoryProgressWorkflow.create(status, workflow, type);

  return (
    <>
      <Box px={2} pt={1} pb={2}>
        <Box width={'100%'} display="flex" flexDirection="column" gridGap={12}>
          <FlexRow>
            <Font display="block" variant="body2" color="title">
              <strong>
                <Text tId={progress.currentStepTextId} />
              </strong>
            </Font>
            <Box display="flex" flexDirection="row" gridGap={16}>
              {/* <Font display="block" variant="body2" color="title">
                  <strong>{workflow.place.progress}%</strong>
                  </Font> */}
              {progress.isValid && (
                <StatusTag
                  type={progress.statusDefinition.colorPaletteName}
                  colorType={progress.statusDefinition.colorType as 'main' | 'dark' | 'light'}
                  labelTextId={progress.statusDefinition.DESCRIPTION_T_ID}
                />
              )}
            </Box>
          </FlexRow>
          <LinearProgress
            value={progress.progressPercentage}
            variant="determinate"
            color={progress.isCompleted ? 'primary' : 'secondary'}
            style={{
              backgroundColor: palette.grey[200],
            }}
          />
        </Box>
      </Box>
      <Box style={{ padding: '8px 16px' }}>
        <Box minWidth={'100%'}>
          {/* <Box className="fade-vertical-wrapper"> */}
          <Box
            display={'flex'}
            flexDirection={'column'}
            alignItems={'flex-start'}
            gridGap={8}
            maxHeight={'230px'}
            style={{ overflowY: 'scroll' }}
          >
            {progress.steps.map((step) => (
              <WorkflowStep key={step} step={step} workflow={progress.workflow} />
            ))}
            <Box pt={1} />
          </Box>
          {/* </Box> */}
        </Box>
      </Box>
    </>
  );
};
